// tslint:disable
export const placeholderChar = ' ';